// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_List = require("rescript/lib/js/belt_List.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var LogicCondition$ReactHooksTemplate = require("../surveys/LogicCondition.res.js");

function id(t) {
  return t.id;
}

function name(t) {
  return t.name;
}

function conditions(t) {
  return t.conditions;
}

function empty(param) {
  return {
          id: undefined,
          name: "",
          conditions: /* [] */0
        };
}

function encodedConditions(t) {
  return Belt_List.toArray(Belt_List.map(t.conditions, (function (x) {
                    return LogicCondition$ReactHooksTemplate.toJson(undefined, x);
                  })));
}

function encode(t, deletedConditions) {
  var allConditions = Belt_List.concat(Belt_List.map(t.conditions, (function (c) {
              return LogicCondition$ReactHooksTemplate.toJson(false, c);
            })), Belt_List.map(deletedConditions, (function (c) {
              return LogicCondition$ReactHooksTemplate.toJson(true, c);
            })));
  return Json_encode.object_({
              hd: [
                "id",
                Json_encode.nullable((function (prim) {
                        return prim;
                      }), t.id)
              ],
              tl: {
                hd: [
                  "name",
                  t.name
                ],
                tl: {
                  hd: [
                    "survey_exclusion_conditions_attributes",
                    Belt_List.toArray(allConditions)
                  ],
                  tl: /* [] */0
                }
              }
            });
}

function decode(dataFields, json) {
  return {
          id: Json_decode.optional((function (param) {
                  return Json_decode.field("id", Json_decode.$$int, param);
                }), json),
          name: Json_decode.field("name", Json_decode.string, json),
          conditions: Json_decode.field("survey_exclusion_conditions", (function (param) {
                  return Json_decode.list((function (__x) {
                                return LogicCondition$ReactHooksTemplate.decode(__x, /* [] */0, dataFields);
                              }), param);
                }), json)
        };
}

exports.id = id;
exports.name = name;
exports.conditions = conditions;
exports.empty = empty;
exports.encodedConditions = encodedConditions;
exports.encode = encode;
exports.decode = decode;
/* LogicCondition-ReactHooksTemplate Not a pure module */
